import { PagingSearch } from "./common"

export class EventAttend {
    eventId: number
    type: string
    userNo: number
    userId: string
    userName: string
    regDate: string
    transId: string
    address: string
    tel: string
    status: string
    statusName: string
    isChecked: boolean
}

export class EventMaster {
    constructor(type: string, typeName: string, comment: string) {
        this.type = type
        this.typeName = typeName
        this.comment = comment
    }
    type: string
    typeName: string
    comment: string
}


export class EventAttendSearch extends PagingSearch{
    userNo: number
    type: string
    statusList: string[]
    status: string
    notStatus: string
    searchType: string
}